<template>
  <div>
    <router-link class="btn btn-info m-2" :to="`/dashboard/routing`">
      Back to Routing
    </router-link>
    <card class="card">
      <div class="col-md-6 p-0">
        <label for="inlineFormInput">Customer Type</label>
        <select class="form-control" v-model="selectedCustomerType">
          <option value="">Select a Customer Type</option>
          <option value="institution">Institution</option>
          <option value="merchant">Agent Category</option>
        </select>
      </div>

      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="number"
                label="Min Amount"
                placeholder="Min Amount"
                v-model="route.minAmount"
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="Max Amount"
                placeholder="Max Amount"
                v-model="route.maxAmount"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Card Type</label>
              <select class="form-control" v-model="route.cardType">
                <option value="">Select a Card Type</option>
                <option value="A000000003">Visa</option>
                <option value="A000000004">Master Card</option>
                <option value="A000000371">Verve</option>
                <option value="A000000065">JCB</option>
                <option value="A000000025">Amex</option>
                <option value="A000000333">CUP</option>
                <option value="A000000152">Dinners</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="number"
                label="Min Bin Range"
                placeholder="Min Bin Range"
                v-model="route.minRange"
              >
              </fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="number"
                label="Max Bin Range"
                placeholder="Max Bin Range"
                v-model="route.maxRange"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <label for="inlineFormInput">Processor</label>
              <select
                class="form-control"
                v-model="route.processor"
                :disabled="!selectedCustomerType"
              >
                <option value="">Select a Processor</option>
                <option value="UPSL">UPSL</option>
                <option value="ISW">ISW</option>
                <option value="3LINE">3LINE</option>
                <option value="ZONE">ZONE</option>
                <option value="UPSL_PTSA">UPSL PTSA</option>
                <option value="NIBSS_PTSA">NIBSS PTSA</option>
                <option value="NIBSS">NIBSS</option>
              </select>
            </div>

            <div class="col-md-6">
              <label for="inlineFormInput">Alternate Processor</label>
              <select
                class="form-control"
                v-model="route.alternateProcessor"
                :disabled="!selectedCustomerType"
              >
                <option value="">Select a Processor</option>
                <option value="UPSL">UPSL</option>
                <option value="ISW">ISW</option>
                <option value="3LINE">3LINE</option>
                <option value="UPSL_PTSA">UPSL PTSA</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6" v-if="auth.user.userType === 'super-admin'">
              <div class="" v-if="selectedCustomerType === 'merchant'">
                <label>Agent Category</label>
                <multiselect
                  v-model="selectedMerchant"
                  :custom-label="optionLabelMerchant"
                  track-by="_id"
                  :options="utils.merchants"
                  :allow-empty="false"
                  placeholder="Select an Agent Category"
                  @close="getAgents"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    {{ option.merchantName }}
                  </template>
                </multiselect>
              </div>
              <div class="" v-if="selectedCustomerType === 'institution'">
                <label>Institution Name</label>
                <multiselect
                  v-model="selectedInstitution"
                  :custom-label="optionLabel"
                  track-by="_id"
                  :options="utils.institutions"
                  :allow-empty="false"
                  placeholder="Select an Institution"
                  @close="getAgents"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    {{ option.institutionName }}
                  </template>
                </multiselect>
              </div>
            </div>
          </div>

          <div class="text-center">
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Create
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedMerchant: "",
      route: {},
      selectedCustomerType: "",
      selectedInstitution: "",
    };
  },
  computed: {
    ...mapState(["loading", "terminal", "utils", "auth"]),
  },
  methods: {
    ...mapActions(["saveRouting", "getMerchants", "getInstitutions"]),
    submit() {
      if (this.selectedCustomerType === "merchant") {
        if (this.selectedMerchant !== "") {
          this.route.merchantId = this.selectedMerchant._id;
        }
      } else if (this.selectedCustomerType === "institution") {
        if (this.selectedInstitution !== "") {
          this.route.institutionId = this.selectedInstitution._id;
        }
      } else {
        {
          setNotification({
            type: "danger",
            message: "Please select a Customer Type",
          });
        }
        return;
      }

      if (this.route.alternateProcessor) {
        this.route.alternateProcessor = this.route.alternateProcessor;
      }
      this.$confirm("Save Routing?").then(() => {
        this.saveRouting(this.route);
      });
    },
    optionLabelMerchant({ merchantName }) {
      return `${merchantName}`;
    },
    optionLabel({ institutionName }) {
      return `${institutionName}`;
    },
  },
  mounted() {
    if (this.auth.user.userType === "super-admin") {
      this.getMerchants();
      console.log(this.getMerchants);
      this.getInstitutions();
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
